function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "n");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M124.33942,123.96867a2.58,2.58,0,0,1-1.30083.34711H4.96466a2.60884,2.60884,0,0,1-2.57246-3.07852c1.09646-6.05975,3.48077-19.08751,4.03225-20.74193,2.73466-8.1748,9.52428-12.087,16.88485-15.14284.94076-.38928,1.89124-.76559,2.84172-1.13539q9.62-3.73221,19.24647-7.46437a20.20855,20.20855,0,0,0,37.20829,0q9.62487,3.73218,19.24647,7.46437c.95048.3698,1.901.74611,2.84172,1.13539,7.36056,3.05581,14.15018,6.968,16.8816,15.14284.55148,1.65442,2.939,14.68218,4.03225,20.74193A2.60937,2.60937,0,0,1,124.33942,123.96867Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M87.27408,50.68491l3.62066-18.65724A24.97838,24.97838,0,0,0,66.14894,3.68422H61.84933A24.97559,24.97559,0,0,0,37.10572,32.02767l3.61957,18.65724a23.71054,23.71054,0,0,0,46.5488,0"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/User.87a61371.svg";
export { ForwardRef as ReactComponent };